import { User } from "@fableous/core/model/User";
import { makeObservableReducer, SyncAction } from "../hooks/hookUtils";

/**
 * force - if not set, then no action will be taken if user Id is the same. If set to true, state guaranteed to update
 */
export type UserAction = { type: "setUser"; value: { user?: User; force?: boolean } } | SyncAction<User | undefined>;

function userReducer(state: User | undefined, action: UserAction): User | undefined {
    switch (action.type) {
        case "setUser":
            if(state && state?.userId === action.value.user?.userId && !action.value?.force) return state;
            return action.value.user;
        case "__sync__":
            return action.payload
        default:
            return state;
    }
}

export const userStore = makeObservableReducer<User | undefined, UserAction>(userReducer, undefined);
